import type { TitleProps } from './title.types';
import { cn } from '@/utils/helper';
import v1 from './title-v1.module.css';
import v2 from './title-v2.module.css';

export default function Title(props: TitleProps) {
  return <h3 className={cn(v1.Title, v2.Title)}>{props.content}</h3>;
}
